import React from "react";
import { motion } from "framer-motion";
import { CategoryKey } from "../types/quiz";
import { profiles } from "../data/profiles";
interface ScoreChartProps {
  scores: Record<CategoryKey, number>;
  primary: CategoryKey;
  secondary: CategoryKey | null;
  name: string;
}
function level(ratio: number) {
  if (ratio >= 0.75) return {
    text: "Alta",
    cls: "bg-coral-100 text-coral-600"
  };
  if (ratio >= 0.4) return {
    text: "Media",
    cls: "bg-blush-100 text-rose-700"
  };
  return {
    text: "Baja",
    cls: "bg-olive-100 text-olive-700"
  };
}
export function ScoreChart({
  scores,
  primary,
  secondary,
  name
}: ScoreChartProps) {
  const max = Math.max(1, ...Object.values(scores));
  const rows = [...profiles].sort((a, b) => scores[b.key] - scores[a.key]);
  return <section aria-labelledby="mapa-title" className="mt-10 rounded-3xl bg-white p-6 sm:p-8" data-id="element-365" data-mp="2jxuu5gqmgcug">
      <h2 id="mapa-title" className="font-serif text-2xl font-semibold text-cocoa" data-id="element-366" data-mp="tpchkb4dthb9">
        Tu mapa digestivo nocturno
      </h2>
      <p className="mt-1 text-sm text-cocoa-soft" data-id="element-367" data-mp="2jpdzj2px2vhw">
        {name ? `${name}, así` : "Así"} pesa cada factor en tu hinchazón según tus respuestas.
      </p>
      <ul className="mt-6 space-y-4" data-id="element-368" data-mp="2oogrpmkst78g">
        {rows.map((p, i) => {
        const ratio = scores[p.key] / max;
        const lv = level(ratio);
        const color = p.key === primary ? "bg-rose-600" : p.key === secondary ? "bg-rose-400" : "bg-blush-200";
        return <li key={p.key} data-id="element-369" data-mp="33ck0t4u50z1h" data-mpi={i}>
              <div className="flex items-center justify-between gap-3" data-id="element-370" data-mp="33ffxyqy5vjov">
                <span className={`text-sm ${p.key === primary ? "font-semibold text-cocoa" : "text-cocoa"}`} data-id="element-371" data-mp="37d3xk7asu0n3">
                  {p.shortName}
                  {p.key === primary && <span className="ml-2 text-xs font-semibold text-rose-600" data-id="element-372" data-mp="3hd4j7zw54sug">Principal</span>}
                  {p.key === secondary && <span className="ml-2 text-xs font-semibold text-rose-600" data-id="element-373" data-mp="1i123n0qn0im2">Secundario</span>}
                </span>
                <span className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold ${lv.cls}`} data-id="element-374" data-mp="1mzdad2lmyd02">{lv.text}</span>
              </div>
              <div className="mt-1.5 h-2.5 w-full overflow-hidden rounded-full bg-cream-dark" data-id="element-375" data-mp="1awk83lk57i9x">
                <motion.div className={`h-full rounded-full ${color}`} initial={{
              width: "0%"
            }} whileInView={{
              width: `${Math.max(ratio * 100, 4)}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: i * 0.05,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-376" data-mp="1owbsc4195uwd" />
              </div>
            </li>;
      })}
      </ul>
    </section>;
}